import { get } from 'lodash';
import React from 'react';
import { Icon, Item, SemanticICONS } from 'semantic-ui-react';

import { useTracking } from '../../../Context';
import { eventTags } from '../../../core/trackers/events';
import { urlify } from '../../../utils/stringUtils';
import { ContactsProps } from '../components/Contacts';

const ContactsVariantLegacy = (props: ContactsProps): JSX.Element => {
  const { trackEvent } = useTracking();
  const { items, infos = [] } = props;
  console.log('la ?');
  return (
    <Item.Group link>
      {items.map((item) => (
        <Item
          key={item._id}
          as="a"
          href={`mailto:${item.email}`}
          target="_blank"
          onClick={() => trackEvent(eventTags.ITEM_CONTACT_CLICK, { item })}
        >
          <Item.Content style={{ width: '100%' }}>
            <Item.Header style={{ fontSize: '1.2em', marginBottom: 0 }}>
              <Icon name="user circle outline" style={{ marginRight: 4 }} /> {item.firstName}{' '}
              {item.lastName}
            </Item.Header>
            {item.fonction && (
              <Item.Meta>
                <Icon name="briefcase" style={{ marginRight: 4 }} />
                {item.fonction}
              </Item.Meta>
            )}
            {item.phoneNumber && (
              <Item.Extra style={{ color: '#777' }}>
                <Icon name="phone" style={{ marginRight: 4 }} />
                {item.phoneNumber}
              </Item.Extra>
            )}
            <Item.Meta style={{ wordBreak: 'break-all' }}>
              <Icon name="envelope outline" style={{ marginRight: 4 }} />
              {item.email}
            </Item.Meta>
            {infos.map((info) => (
              <Item.Meta key={info.name} style={{ wordBreak: 'break-word' }}>
                {(info.blocks || []).map((field) => {
                  const value = get(item, field.field);
                  if (!value) return null;

                  return (
                    <React.Fragment key={field.field}>
                      {field?.icon && (
                        <Icon name={field.icon as SemanticICONS} style={{ marginRight: 4 }} />
                      )}
                      {urlify(value)}
                    </React.Fragment>
                  );
                })}
              </Item.Meta>
            ))}
          </Item.Content>
        </Item>
      ))}
    </Item.Group>
  );
};

export default ContactsVariantLegacy;
